const indexItems = [
  { title: '台北娜娜 · 完整专题索引', count: '47篇', desc: '涵盖台北娜娜所有独家爆料、视频解读与深度分析文章' },
  { title: '莫里秀 · 黑料证据链合集', count: '35篇', desc: '莫里秀相关黑料的完整时间线与多维度揭秘专题' },
  { title: '玩偶姐姐 · 视频内容全收录', count: '52篇', desc: '玩偶姐姐所有精彩视频的图文解读与深度内容合集' },
  { title: '暗网吃瓜 · 每日更新汇总', count: '189篇', desc: '暗网吃瓜每日更新内容的完整存档入口，方便回顾' },
  { title: '51吃瓜 · 热门人物图谱', count: '28篇', desc: '51吃瓜旗下热门人物的关系图谱与互动动态追踪' },
  { title: '吃瓜爆料 · 独家线人消息', count: '63篇', desc: '来自暗网吃瓜线人的独家爆料消息，未经公开信息来源' },
  { title: '八卦回顾 · 经典事件专题', count: '41篇', desc: '台北娜娜、莫里秀历史重要事件的完整回顾与深度分析' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          人物专题索引
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          七大核心专题，一键直达你最关心的人物内容
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexItems.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="lg:col-span-1 xl:col-span-1 group block rounded-xl border border-background-200/60 bg-background-50 p-5 transition-all duration-300 hover:border-primary-500/30 hover:translate-y-[-2px] cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-primary-400 font-medium bg-primary-500/10 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </div>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
          {indexItems.slice(3).map((item, i) => (
            <a
              key={i + 3}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl border border-background-200/60 bg-background-50 p-5 transition-all duration-300 hover:border-primary-500/30 hover:translate-y-[-2px] cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-primary-400 font-medium bg-primary-500/10 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </div>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}